export const CHANGE_SELECTED_ADMIN_OBJECT = 'CHANGE_SELECTED_ADMIN_OBJECT';
export const STOP_FETCHING_ADMIN_OBJECT = 'STOP_FETCHING_ADMIN_OBJECT';
